(() => {
  const hasFine = window.matchMedia('(pointer: fine)').matches;
  if (!hasFine) return;

// --- STYLE CONSTANTS ---
const ACCENT_COLOR    = '#6B4FD8'; // Indigo — the lead dot
const BRAND_OFF_WHITE = '#D4C8FF'; // Cool lavender white — eye on hover
const BRAND_BLACK     = '#080810'; // Deep space black

// Nebula Indigo Palette
const CHROME_LIGHT     = '#8B6FE8'; // Soft violet-indigo
const CHROME_MID       = '#4A2FB0'; // Deep indigo
const CHROME_DARK      = '#1A0A4F'; // Near-black indigo
const CHROME_HIGHLIGHT = '#C4A8FF'; // Very pale lavender glint (replaces hot pink)

  const canvas = document.createElement('canvas');
  canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:99999;';
  document.body.appendChild(canvas);
  document.body.style.cursor = 'none';

  const style = document.createElement('style');
  style.textContent = '*, *::before, *::after { cursor: none !important; }';
  document.head.appendChild(style);

  const ctx = canvas.getContext('2d');
  let W, H, dpr;

  function resize() {
    dpr = window.devicePixelRatio || 1;
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize);

  let mouseX = -999, mouseY = -999;
  let subX = -999, subY = -999;
  let prevSubX, prevSubY;
  let propAngle = 0;
  let initialized = false;
  let isHoveringLink = false;

  document.addEventListener('mousemove', e => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    if (!initialized) {
      subX = mouseX + 40;
      subY = mouseY + 8;
      prevSubX = subX;
      prevSubY = subY;
      initialized = true;
    }
    const el = document.elementFromPoint(mouseX, mouseY);
    isHoveringLink = !!el && !!el.closest('a, button, [role="button"], input, select, textarea, label');
  });

  function drawChromeSub(s, propAng, isHover) {
    // Body Gradient
    const grad = ctx.createLinearGradient(-22*s, -18*s, -22*s, 18*s);
   grad.addColorStop(0,   '#B090E8'); // pale violet-pink (subtle, not magenta)
   grad.addColorStop(0.2, '#8B6FE8'); // soft violet
   grad.addColorStop(0.5, '#4A2FB0'); // true indigo
   grad.addColorStop(0.8, '#1A0A4F'); // deep space
   grad.addColorStop(1,   '#1A0A60'); // black

    const shaftW = 1.6*s, hubX = 27*s, hubR = 2.8*s;
    const bladeLen = 6*s, bladeW = 1.6*s;

    // Shaft
    ctx.fillStyle = CHROME_DARK;
    ctx.beginPath();
    ctx.roundRect(16*s, -shaftW/2, hubX-16*s, shaftW, shaftW/2);
    ctx.fill();

    // Blades
    for (let i = 0; i < 3; i++) {
      const a = propAng + (i * Math.PI * 2 / 3);
      ctx.save();
      ctx.translate(hubX, 0);
      ctx.rotate(a);
      const bg = ctx.createLinearGradient(-bladeW, -bladeLen*0.55, bladeW, bladeLen*0.55);
      bg.addColorStop(0, CHROME_MID);   
      bg.addColorStop(0.6, CHROME_DARK); 
      bg.addColorStop(1, BRAND_BLACK);    
      ctx.fillStyle = bg;
      ctx.beginPath();
      ctx.ellipse(0, -bladeLen*0.55, bladeW, bladeLen, 0, 0, Math.PI*2);
      ctx.fill();
      ctx.restore();
    }

    // Hub
    ctx.fillStyle = CHROME_MID;
    ctx.beginPath(); ctx.arc(hubX, 0, hubR, 0, Math.PI*2); ctx.fill();
    ctx.fillStyle = BRAND_BLACK;
    ctx.beginPath(); ctx.arc(hubX, 0, hubR*0.35, 0, Math.PI*2); ctx.fill();

    // Body
    ctx.fillStyle = grad;
    ctx.beginPath();
    ctx.moveTo(18*s, 0);
    ctx.bezierCurveTo(18*s, -12*s, 6*s, -18*s, -6*s, -18*s);
    ctx.bezierCurveTo(-16*s, -18*s, -22*s, -10*s, -22*s, 0);
    ctx.bezierCurveTo(-22*s, 10*s, -16*s, 18*s, -6*s, 18*s);
    ctx.bezierCurveTo(6*s, 18*s, 18*s, 12*s, 18*s, 0);
    ctx.closePath(); ctx.fill();

    // Eye
    const ex = -9*s, ey = -4*s, er = 5*s;
    ctx.fillStyle = BRAND_BLACK;
    ctx.beginPath(); ctx.arc(ex, ey, er, 0, Math.PI*2); ctx.fill();

    // Pupil switches to Brand Off-White on hover
    ctx.fillStyle = isHover ? BRAND_OFF_WHITE : CHROME_MID;
    ctx.beginPath(); ctx.arc(ex, ey, er * 0.5, 0, Math.PI*2); ctx.fill();
    
    ctx.strokeStyle = CHROME_MID; ctx.lineWidth = 0.8*s;
    ctx.beginPath(); ctx.arc(ex, ey, er, 0, Math.PI*2); ctx.stroke();
  }

  function animate() {
    requestAnimationFrame(animate);
    ctx.clearRect(0, 0, W, H);
    if (!initialized) return;

    subX += ((mouseX + 40) - subX) * 0.1;
    subY += ((mouseY + 8) - subY) * 0.1;
    window.__merouCursor = { subX, subY };

    const dx = subX - prevSubX, dy = subY - prevSubY;
    propAngle += Math.sqrt(dx*dx + dy*dy) * 0.12;
    prevSubX = subX; prevSubY = subY;

    ctx.save();
    ctx.translate(subX, subY);
    drawChromeSub(0.55, propAngle, isHoveringLink);
    ctx.restore();

    // Lead Dot - Always the Accent Color
    ctx.beginPath();
    ctx.arc(mouseX, mouseY, 3, 0, Math.PI*2);
    ctx.fillStyle = ACCENT_COLOR;
    ctx.fill();
  }
  animate();
})();